import React, { useState, useEffect } from 'react';
import './DateTimeInput.css';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';

export default function DateTimeInput({ initialValue, rules, minDate, maxDate, onValidate, name, label, instructions, showError, errorMessages, readOnly, tabIndex, showDate, showTime }) {

  const getYearArray = () => {
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput getYearArray'); }
    var startYear = (minDate ? minDate : new Date()).getFullYear();
    var endYear = (maxDate ? maxDate : new Date()).getFullYear();
    return range(startYear, endYear, 1);
  }

  const getDayArray = (date) => {
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput getDayArray'); }
    var monthDays = daysInMonth(date.getFullYear(), date.getMonth() + 1);
    return range(1, monthDays, 1);
  }
  const range = (start, end, step = 1) => {
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput range'); }
    const len = Math.floor((end - start) / step) + 1
    return Array(len).fill().map((_, idx) => start + (idx * step))
  }

  const daysInMonth = (year, month) => {
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput updatedaysInMonthTimeValue'); }
    return new Date(year, month, 0).getDate();
  };

  const [monthItems, setMonthItems] = useState([
    {
      "value": 1,
      "abbreviation": "Jan",
      "name": "January"
    },
    {
      "value": 2,
      "abbreviation": "Feb",
      "name": "February"
    },
    {
      "value": 3,
      "abbreviation": "Mar",
      "name": "March"
    },
    {
      "value": 4,
      "abbreviation": "Apr",
      "name": "April"
    },
    {
      "value": 5,
      "abbreviation": "May",
      "name": "May"
    },
    {
      "value": 6,
      "abbreviation": "Jun",
      "name": "June"
    },
    {
      "value": 7,
      "abbreviation": "Jul",
      "name": "July"
    },
    {
      "value": 8,
      "abbreviation": "Aug",
      "name": "August"
    },
    {
      "value": 9,
      "abbreviation": "Sep",
      "name": "September"
    },
    {
      "value": 10,
      "abbreviation": "Oct",
      "name": "October"
    },
    {
      "value": 11,
      "abbreviation": "Nov",
      "name": "November"
    },
    {
      "value": 12,
      "abbreviation": "Dec",
      "name": "December"
    }
  ]);
  const [dayItems, setDayItems] = useState(getDayArray((initialValue ? initialValue : new Date())));
  const [yearItems, setYearItems] = useState(getYearArray());
  const [ampmItems, setampmItems] = useState(["AM", "PM"]);
  const [valueMonth, setValueMonth] = useState((initialValue ? initialValue.getMonth() : (new Date()).getMonth() + 1));
  const [valueDay, setValueDay] = useState((initialValue ? initialValue.getDate() : (new Date()).getDate()));
  const [valueYear, setValueYear] = useState((initialValue ? initialValue.getFullYear() : (new Date()).getFullYear()));
  const [valueTime, setValueTime] = useState((initialValue ? ((((initialValue.getHours() + 1) % 13).toString() + ":" + initialValue.getMinutes().toString().padStart(2, '0'))) : (((((new Date()).getHours() + 1) % 13).toString() + ":" + (new Date()).getMinutes().toString().padStart(2, '0')))));
  const [valueAMPM, setValueAMPM] = useState((initialValue ? ((initialValue.getHours() + 1) > 11 ? "PM" : "AM") : (((new Date()).getHours() + 1) > 11 ? "PM" : "AM")));
  const [isValid, setIsValid] = useState(null);
  const [validationDetails, setValidationDetails] = useState(null);
  const fieldIsValid = isValid;

  if (logComponent('DateTimeInput')) { console.debug('DateTimeInput rendered'); }


  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput setNativeCheckboxRef'); }
    validateThis();
  }, []);

  const updateTimeValue = (e) => {
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput updateTimeValue'); }
    setValueTime(e.target.value);

  }

  const updateAMPMValue = (e) => {
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput updateAMPMValue'); }
    setValueAMPM(e.target.value);

  }

  const updateMonthValue = (e) => {
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput updateMonthValue'); }
    setValueMonth(e.target.value);

  }

  const updateDayValue = (e) => {
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput updateDayValue'); }
    setValueDay(e.target.value);

  }

  const updateYearValue = (e) => {
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput updateYearValue'); }
    setValueYear(e.target.value);

  }

  const validateThis = () => {
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput validateThis'); }

    let rulesToCheck = Object.assign({}, rules);

    if (rules.required) {
      rulesToCheck.validTime = true;
    }

    let validationDetails = {};

    for (let rule in rulesToCheck) {
      validationDetails[rule] = validate[rule](valueTime, rulesToCheck[rule]);
    }

    let isValidLocal = Object.values(validationDetails).reduce((prev, curr) => prev && curr, true);

    setValidationDetails(validationDetails);
    setIsValid(isValidLocal);

    let date = showDate ? valueMonth.toString() + "/" + valueDay.toString() + "/" + valueYear.toString() : "";
    let separator = showDate && showTime ? " " : "";
    let time = showTime ? valueTime + " " + valueAMPM : "";

    let combinedValue = new Date(date + separator + time);

    onValidate({
      name: name,
      isValid: isValidLocal,
      value: combinedValue
    });
  }

  const handleBlur = () => {
    if (logComponent('DateTimeInput')) { console.debug('DateTimeInput handleBlur'); }
    validateThis();
  }



  return (
    <div className="Date-Time-Input-Group">
      {
        showError && !fieldIsValid &&
        errorMessages.map((message, index) => {
          if (message.rules.some(rule => validationDetails[rule] === false)) {
            return <p key={index} className="Date-Time-Input-Group__error">{message.text}</p>;
          }
        })
      }
      <label
        className="Date-Time-Input-Group__label"
        htmlFor={name + '-input'}>
        {label}{
          rules && rules.required &&
          <span className="Date-Time-Input-Group__required"> *</span>
        }
      </label>
      {
        instructions &&
        <span className="Date-Time-Input-Group__instructions">{instructions}</span>
      }
      <div>
        {showTime &&
          <input
            id={name + '-input'}
            className="Date-Time-Input-Group__input"
            type="text"
            spellCheck="false"
            tabIndex={tabIndex}
            readOnly={readOnly}
            value={valueTime}
            onChange={updateTimeValue}
            onBlur={handleBlur} />
        }
        {showTime &&
          <select
            id={name + '-input-ampm'}
            className={'Date-Time-Input-Group__select'}
            disabled={readOnly}
            tabIndex={tabIndex + 1}
            value={valueAMPM}
            onBlur={handleBlur}
            onChange={updateAMPMValue} >
            {
              ampmItems.map(item =>
                <option value={item} key={item}>{item}</option>
              )
            }
          </select>
        }
        {showDate &&
          <select
            id={name + '-input-months'}
            className={'Date-Time-Input-Group__select'}
            disabled={readOnly}
            tabIndex={tabIndex + 3}
            value={valueMonth}
            onBlur={handleBlur}
            onChange={updateMonthValue} >
            {
              monthItems.map(item =>
                <option value={item.value} key={item.value}>{item.name}</option>
              )
            }
          </select>
        }
        {showDate &&

          <select
            id={name + '-input-days'}
            className={'Date-Time-Input-Group__select'}
            disabled={readOnly}
            tabIndex={tabIndex + 4}
            value={valueDay}
            onBlur={handleBlur}
            onChange={updateDayValue} >
            {
              dayItems.map(item =>
                <option value={item} key={item}>{item}</option>
              )
            }
          </select>
        }
        {showDate &&
          <select
            id={name + '-input-years'}
            className={'Date-Time-Input-Group__select'}
            disabled={readOnly}
            tabIndex={tabIndex + 5}
            value={valueYear}
            onBlur={handleBlur}
            onChange={updateYearValue} >
            {
              yearItems.map(item =>
                <option value={item} key={item}>{item}</option>
              )
            }
          </select>
        }
      </div>
    </div>
  );
}